{
    "raporgunlukisler": {
        "Baslik": "Günlük İşler Raporu",
        "Tarih": "Tarih",
        "Kullanici": "Kullanıcı",
        "Aciklama": "Dosya / İşlem Açıklaması",
        "Saat": "Saat",
        "Arama": "Arama",
        "Ara": "Ara",
        "Kapat": "Kapat",
        "Temizle": "Temizle",
        "BaslangicTarihi": "Başlangıç Tarihi",
        "BitisTarihi": "Bitiş Tarihi",
        "BaslamaSaat": "Başlama Saat",
        "BitisSaat": "Bitiş Saat",
        "Islemler": "İşlemler",
        "Duzenle": "Düzenle",
        "Sil": "Sil",
        "Guncelle": "Güncelle",
        "EminMisiniz": "Emin misiniz?",
        "GeriAlamazsiniz": "Bu işlem geri alınamaz!",
        "EvetSil": "Evet, sil!",
        "Iptal": "İptal",
        "GoruntuleTooltip": "Görüntüle",
        "SilTooltip": "Sil",
        "Kapsam": "Kapsam",
        "Takim": "Takım",
        "Sube": "Şube",
        "Kendi": "Kendi",
        "Tam": "Tam"
    }
}
